import styled, { css } from 'styled-components';

export const DropDownWrapper = styled.div`
  position: absolute;
  
  background: #FFFFFF;

  border: 1px solid #E3E3E3;
  box-sizing: border-box;

  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
  border-radius: 12px;

  z-index: 10;

  right: 0;

  /* overflow: hidden; */

  ${p => p.openOnTop ? css`
    bottom: calc(100% + 5px);
  ` : css`
    margin-top: ${p.marginTop ? p.marginTop : '5px'};
  `}

  ${p => p.inheritParent && css`
    width: 100%;
    background: #FFFFFF;

    border: 1px solid #E3E3E3;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    /* padding: 10px; */
    max-height: ${p.maxHeight ?? '350px'};
    overflow-y: auto;

    scrollbar-width: none;
    ::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
  `}
`;
